import { createContext, useContext, useEffect, useMemo } from "react";
import { Translation } from "react-i18next";
import { PermissionsStatusComponent } from "../permissionsStatusComponent/PermissionsStatusComponent";
import './LandingPage.scss';
import Jurisdiction from "../../models/Jurisdiction";
import { GlobalAuthInfoContext } from "../mainWrapper/MainWrapper";
import { SidebarContext } from "../../core/SidebarComponent";
import { Outlet } from "react-router-dom";

export const JurisdictionContext = createContext<Jurisdiction[] | null>(null);

export const LandingPage = () => {
    const globalAuthInfoContext = useContext(GlobalAuthInfoContext);

    const { dispatchSidebar } = useContext(SidebarContext);

    useEffect(() => {
        dispatchSidebar({
            type: "open",
            payload: { name: "Reports", content: null },
        });
    }, [dispatchSidebar])

    const jurisdictionList: Jurisdiction[] | null = useMemo(() => {
        if (globalAuthInfoContext.jurisdictionList !== undefined) {
            return globalAuthInfoContext.jurisdictionList.sort((a: any, b: any) => { return (a.displayWeight - b.displayWeight) })
        }
        else {
            return null;
        }
    }, [globalAuthInfoContext.jurisdictionList]);

    return (
        <div className="landing-page">
            <PermissionsStatusComponent hasPermissions={true}>
                {/* TODO: Figure out permissions */}
                {jurisdictionList.length > 0 &&
                    <Outlet />}
            </PermissionsStatusComponent>
        </div >
    )
}
